<section class="esignature-errand-form">
  <app-form-header [menuDefinition]="menuDefinition" (onSave)="onSubmit()" (onCancel)="cancel()"></app-form-header>
  @if (dataContext && form) {
    <div>
      <!-- Below code is the scenario when working with a saved esignature errand-->
      @if (!dataContext.isNew) {
        <astral-form
          [form]="form"
          [columns]="4"
          [tabletColumns]="2"
          [mobileColumns]="1"
          [columnGap]="'16px'"
          (formSubmit)="onSubmit()"
          >
          <section class="astral-section-surface astral-grid-full">
            <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" [columnGap]="'16px'">
              <astral-input [control]="form.controls['statusText']"></astral-input>
              <astral-input [control]="form.controls['createdAt']"></astral-input>
              @if (form.controls['completedAt'].value) {
                <astral-input [control]="form.controls['completedAt']"></astral-input>
              }
              <div class="astral-grid-desktop-span-2">
                <astral-input [control]="form.controls['errandDescription']" [helpText]="'ESIGNATURE.HELP_TEXT.DESCRIPTION'"></astral-input>
              </div>
              <astral-input [control]="form.controls['companyCaption']"></astral-input>
              @if (hasLinkToLeaseAgreement) {
                <astral-input [control]="form.controls['leaseAgreementNumber']"></astral-input>
              }
              <astral-date-picker
                [control]="form.controls['expirationDate']"
                [label]="'ESIGNATURE.EXPIRATION_DATE'"
                [helpText]="'ESIGNATURE.HELP_TEXT.EXPIRATION_DATE'"
              ></astral-date-picker>
              @if (form.controls['cancelledAt'].value) {
                <astral-input [control]="form.controls['cancelledAt']"></astral-input>
              }
              <astral-select
                [control]="form.controls['signatureContext']"
                [itemsSource]="signatureContexts"
                [helpText]="'ESIGNATURE.HELP_TEXT.CONTEXT_TYPES'"
              ></astral-select>
            </astral-layout-group>
          </section>
          <section class="esignature-errand-form__signatories astral-grid-full astral-form-stack astral-form-stack--relaxed">
            <h4 class="esignature-errand-form__section-title">{{ 'ESIGNATURE.SIGNATORIES' | translate }}</h4>
            <div class="astral-accordion-stack">
              @for (sform of signatoryForms; track sform) {
              <astral-accordion [header]="sform.controls['name'].value" [translateHeader]="false">
                <div class="esignature-errand-form__accordion-panel">
                  <astral-layout-group [columns]="4" [tabletColumns]="1" [mobileColumns]="1" [columnGap]="'16px'">
                    <astral-input [control]="sform.controls['name']"></astral-input>
                    <astral-select
                      [control]="sform.controls['informationChannel']"
                      [itemsSource]="informationChannels"
                      [helpText]="'ESIGNATURE.HELP_TEXT.INFORMATION_CHANNEL'"
                    ></astral-select>
                    <astral-input [control]="sform.controls['email']" [type]="'email'" [inputMode]="'email'"></astral-input>
                    <astral-input [control]="sform.controls['phone']" [type]="'phone'" [inputMode]="'tel'"></astral-input>
                    <astral-select
                      [control]="sform.controls['signingRole']"
                      [itemsSource]="signingRoles"
                      [helpText]="'ESIGNATURE.HELP_TEXT.SIGNING_ROLE'"
                    ></astral-select>
                    <astral-select [control]="sform.controls['signatureType']" [itemsSource]="signatureTypeSelection"></astral-select>
                    <div>
                      <app-masked-text-box
                        [control]="sform.controls['civicNumber']"
                        [mask]="civicNumberMask"
                        [helpText]="'ESIGNATURE.HELP_TEXT.CIVIC_NUMBER'"
                        [maskFormat]="civicNumberMaskFormat"
                      ></app-masked-text-box>
                    </div>
                    <astral-select
                      [control]="sform.controls['signatureReminderSetting']"
                      [helpText]="'ESIGNATURE.HELP_TEXT.SIGNATURE_REMINDER_SETTING'"
                      [itemsSource]="signatureReminderSettingSelection"
                    ></astral-select>
                    @if (showEmail(sform)) {
                      <astral-input [control]="sform.controls['emailDeliveryStatusText']"></astral-input>
                    }
                    <astral-input class="astral-grid-full" [control]="sform.controls['signUrl']"></astral-input>
                    <astral-input
                      inputId="esignature-info-sent-at"
                      [label]="'ESIGNATURE.SIGNATORY.INFO_SENT_AT'"
                      [value]="formatDateTime(sform.controls['informationSentAt'].value) || ''"
                      [readonly]="true"
                    ></astral-input>
                    @if (sform.controls['firstReadAt'].value) {
                      <astral-input
                        inputId="esignature-first-read-at"
                        [label]="'ESIGNATURE.SIGNATORY.FIRST_READ'"
                        [value]="formatDateTime(sform.controls['firstReadAt'].value) || ''"
                        [readonly]="true"
                      ></astral-input>
                    }
                    @if (sform.controls['rejectedAt'].value) {
                      <astral-input
                        inputId="esignature-rejected-at"
                        [label]="'ESIGNATURE.SIGNATORY.REJECTED_AT'"
                        [value]="formatDateTime(sform.controls['rejectedAt'].value) || ''"
                        [readonly]="true"
                      ></astral-input>
                    }
                    @if (sform.controls['signedAt'].value) {
                      <astral-input
                        inputId="esignature-signed-at"
                        [label]="'ESIGNATURE.SIGNATORY.SIGNED_AT'"
                        [value]="formatDateTime(sform.controls['signedAt'].value) || ''"
                        [readonly]="true"
                      ></astral-input>
                    }
                  </astral-layout-group>
                </div>
              </astral-accordion>
              }
            </div>
          </section>
        </astral-form>
      }
      <!-- Below code is the scenario when creating new esignature errand-->
      @if (dataContext.isNew) {
        <astral-form
          [form]="form"
          [columns]="1"
          [tabletColumns]="1"
          [mobileColumns]="1"
          [rowGap]="'var(--astral-form-related-gap)'"
          (formSubmit)="onSubmit()"
          >
          <section class="astral-section-surface astral-form-stack">
            <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" [columnGap]="'16px'">
              <p class="astral-grid-desktop-span-2 help-text">{{ 'ESIGNATURE.HELP_TEXT.DOCUMENT_SEND' | translate }}</p>
              <div class="astral-grid-full">
                <div class="esignature-errand-form__upload-field">
                  <label class="esignature-errand-form__upload-label" for="esignature-upload-file">{{ 'DOCUMENT.PDF_FILE' | translate }}</label>
                  <div class="esignature-errand-form__upload-input-shell">
                    <astral-button
                      class="esignature-errand-form__upload-button"
                      variant="primary"
                      type="button"
                      labelKey="DOCUMENT.SELECT_FILE_UPLOAD"
                      icon="pdf"
                      (click)="uploadFile.click()"
                    ></astral-button>
                    <span class="esignature-errand-form__upload-file-title">
                      {{ form.controls['document'].value?.name || '' }}
                    </span>
                    <input
                      id="esignature-upload-file"
                      type="file"
                      accept="application/pdf,.pdf"
                      (change)="onFileChange($event.target.files)"
                      #uploadFile
                      />
                  </div>
                </div>
              </div>
              <div class="astral-grid-desktop-span-2">
                <astral-input [control]="form.controls['errandDescription']" [helpText]="'ESIGNATURE.HELP_TEXT.DESCRIPTION'"></astral-input>
              </div>
              <astral-select
                [control]="form.controls['companyId']"
                [itemsSource]="companies"
                placeholderText="ESIGNATURE.SELECT_COMPANY"
                [helpText]="'ESIGNATURE.HELP_TEXT.COMPANY'"
              ></astral-select>
              <astral-date-picker
                [control]="form.controls['expirationDate']"
                [label]="'ESIGNATURE.EXPIRATION_DATE'"
                [helpText]="'ESIGNATURE.HELP_TEXT.EXPIRATION_DATE'"
              ></astral-date-picker>
              <astral-toggle [control]="form.controls['informWhenSigned']" [helpText]="'ESIGNATURE.HELP_TEXT.INFORM_WHEN_SIGNED'"></astral-toggle>
              @if (form.controls['informWhenSigned'].value) {
                <div class="astral-grid-desktop-span-3">
                  <astral-input
                    [control]="form.controls['informEmailAddress']"
                    [helpText]="'ESIGNATURE.HELP_TEXT.INFORM_EMAIL_ADRESSES'"
                  ></astral-input>
                </div>
              }
            </astral-layout-group>
          </section>
          <section class="esignature-errand-form__signatories astral-form-stack astral-form-stack--relaxed">
            <h4 class="esignature-errand-form__section-title">{{ 'ESIGNATURE.SIGNATORIES' | translate }}</h4>
            <div class="astral-form-stack astral-form-stack--relaxed">
              @for (sform of signatoryForms; track sform; let i = $index) {
                <section class="esignature-errand-form__signatory-card astral-section-surface astral-section-surface--compact astral-section-surface--subtle">
                  <astral-layout-group [columns]="4" [tabletColumns]="1" [mobileColumns]="1" [columnGap]="'16px'">
                    <astral-input [control]="sform.controls['name']"></astral-input>
                    <astral-select
                      [control]="sform.controls['informationChannel']"
                      [itemsSource]="informationChannels"
                      [helpText]="'ESIGNATURE.HELP_TEXT.INFORMATION_CHANNEL'"
                    ></astral-select>
                    <astral-input [control]="sform.controls['email']" [type]="'email'" [inputMode]="'email'"></astral-input>
                    <astral-input [control]="sform.controls['phone']" [type]="'phone'" [inputMode]="'tel'"></astral-input>
                    <astral-select
                      [control]="sform.controls['signingRole']"
                      [itemsSource]="signingRoles"
                      [helpText]="'ESIGNATURE.HELP_TEXT.SIGNING_ROLE'"
                    ></astral-select>
                    <astral-select [control]="sform.controls['signatureType']" [itemsSource]="signatureTypeSelection"></astral-select>
                    <div>
                      <app-masked-text-box
                        [control]="sform.controls['civicNumber']"
                        [mask]="civicNumberMask"
                        [helpText]="'ESIGNATURE.HELP_TEXT.CIVIC_NUMBER'"
                        [maskFormat]="civicNumberMaskFormat"
                      ></app-masked-text-box>
                    </div>
                    <astral-select
                      [control]="sform.controls['signatureReminderSetting']"
                      [helpText]="'ESIGNATURE.HELP_TEXT.SIGNATURE_REMINDER_SETTING'"
                      [itemsSource]="signatureReminderSettingSelection"
                    ></astral-select>
                    @if (i > 0) {
                      <div class="esignature-errand-form__signatory-delete-slot astral-form-adjacent-action">
                        <astral-button variant="secondary" size="small" type="button" labelKey="DELETE_BTN" icon="trash" (click)="deleteSignatory(i)"></astral-button>
                      </div>
                    }
                  </astral-layout-group>
                </section>
              }
            </div>
            <div class="astral-form-actions astral-form-actions--start">
              <astral-button variant="primary" size="small" type="button" labelKey="ESIGNATURE.ADD_SIGNATORY" icon="plus" (click)="newSignatory()"></astral-button>
            </div>
          </section>
          </astral-form>
        }
      </div>
    }
  </section>
